import moment from 'moment-timezone';

class CustomDate {
  constructor(date = new Date()) {
    this.date = moment.tz(date, 'Etc/Greenwich');

    return this.date;
  }
}

export default CustomDate;
